// Registers /sw.js in production browsers. Called from src/index.js after
// MSAL boots so SW registration never competes with first paint or sign-in.
//
// Localhost dev (yarn start) is intentionally skipped — debugging an active
// SW against the CRA dev server is more pain than the offline-shell payoff.
//
// Registration failures bubble as an unhandled promise rejection so Sentry
// captures them; no console noise.

const isProduction = process.env.NODE_ENV === 'production';
const isLocalhost = (() => {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1' || host === '[::1]';
})();

export function registerServiceWorker() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  if (!isProduction) return;
  if (isLocalhost) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' });
  });
}

export function unregisterServiceWorker() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch(() => {});
}
